import { Component, HostListener, Input } from '@angular/core';

@Component({
  selector: 'app-selection-indicator',
  templateUrl: './selection-indicator.component.html',
  styleUrls: ['./selection-indicator.component.scss']
})
export class SelectionIndicatorComponent {
  shouldShowCheck: boolean = false;
  animationDirection: 'In' | 'Out' | null = null;
  @Input() shouldAnimate = false;
  @Input() set isVisible(value: boolean) {
    if (!this.shouldAnimate) {
      this.shouldShowCheck = value;
    } else {
      this.animationDirection = value ? 'In' : 'Out';
      if (value) {
        this.shouldShowCheck = true;
      }
    }
  };
  @Input() isUnavailable = false;

  @HostListener('animationend', ['$event.target'])
  viewContainerAnimationEnd(target: HTMLElement) {
    if (target.classList.contains('SelectionIndicator')) {
      if (this.animationDirection === 'Out') {
        this.shouldShowCheck = false;
      }

      this.animationDirection = null;
    }
  }
}
